<script setup>
import { computed } from 'vue';

const props = defineProps({
  imgSource: { type: String },
  tag: { type: String },
  longTag: { type: String },
  active: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(['click']);

const postTags = computed(() => {
  // Split each word and return array with first letter capitalized
  if (!props.tag) return [];
  return props.tag
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1));
});

const tooltipText = computed(() => {
  if (props.loading) {
    return `Loading ${props.longTag || props.tag}...`;
  }
  return props.longTag || props.tag || '';
});

function handleClick(event) {
  emit('click', event);
}
</script>

<template>
  <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events -->
  <div
    v-tooltip:right="tooltipText || tag"
    class="flex flex-col items-center justify-center cursor-pointer hover:brightness-90 transition duration-150"
    @click="handleClick"
  >
    <!-- Icon container with optional micro-spinner ring when loading -->
    <div class="icon-wrapper relative flex items-center justify-center">
      <img
        class="icon max-w-10 transition-transform duration-200"
        :class="{ 'scale-105': active }"
        :src="`/icons/app_icons/${imgSource}`"
        alt=""
      >
    </div>

    <!-- Tags -->
    <p
      v-for="(postTag, index) in postTags"
      :key="index"
      class="button-tag transition-colors duration-200"
      :class="{ 'button-tag--active': active }"
    >
      {{ postTag }}
    </p>
  </div>
</template>

<style scoped>
.icon-wrapper {
  position: relative;
}

.button-tag {
  font-size: 11px;
  line-height: 1.15;
  color: var(--md-text-secondary, #a3a3a3);
  margin-top: 4px;
  text-align: center;
}

.button-tag--active {
  color: var(--md-primary, #00bcd4);
}
</style>
